import { useState } from 'react';

// Drop-in <img> replacement: paints a ~1KB blurred placeholder instantly
// while the real image streams in (critical on slow networks).
export const SmartImage = ({ src, blurSrc, eager = false, blurFit = 'cover', style, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : 'auto'}
      decoding="async"
      onLoad={() => setLoaded(true)}
      style={{
        ...(blurSrc && !loaded
          ? { backgroundImage: `url("${blurSrc}")`, backgroundSize: blurFit, backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }
          : {}),
        ...style,
      }}
      {...rest}
    />
  );
};

export default SmartImage;
